import React, { useState, useRef } from 'react';
import { FormikValues } from 'formik';
import styled from 'styled-components';
import { Card } from '@material-ui/core';
import { Editor } from '@tinymce/tinymce-react';
import DescriptionIcon from '@material-ui/icons/Description';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';

const getDescriptionString = (description: any): string => {
  let paragraph: string = '';
  if (description?.content) {
    description.content.forEach((item: any) => {
      if (item.type === 'paragraph') {
        item.content.forEach((content: any) => {
          if (content.type === 'text') {
            paragraph += content.text + '<br/>';
          }
        });
      }
    });
  } else if (description) {
    paragraph = description;
  }
  return paragraph;
};

const StyledEditor = styled.div`
  margin-top: 5px;
  height: 200px;
`;

export interface JiraIdCardProps {
  issue: any;
}

const JiraIdCard: React.FC<JiraIdCardProps> = ({ issue }) => {
  const { fields } = issue;
  const formikRef = useRef<FormikValues>();
  const isEditable = issue.status !== 'approved';
  const [descriptions] = useState(getDescriptionString(fields.description));

  return (
    <Card>
      <CardTitle>
        <DescriptionIcon />
        ID
      </CardTitle>
      <CardContent padding='medium'>
        <InlineFormik
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{}}
          onSubmit={() => {}}
        >
          <InlineForm>
            <InlineTextField
              name='title'
              label='Title'
              value={issue.fields.summary}
            />
            <div style={{ flex: 1, padding: 10 }}>
              <label>Description</label>
              <StyledEditor>
                <Editor
                  apiKey='28wr7ysrep8u469n6qqpzvzmn9uyye4phxcstpwrtdh6blk1'
                  value={descriptions}
                  init={{
                    height: '100%',
                    menubar: false,
                    contextmenu: false,
                    browser_spellcheck: true,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help | code'
                  }}
                  disabled={!isEditable}
                  onEditorChange={() => {}}
                />
              </StyledEditor>
            </div>
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default JiraIdCard;
